import languageHelper from "./languageHelper";

const language = languageHelper();

const required = value => (value ? undefined : language.errors.required);

export default { required };
